
import React, { useEffect, useRef, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import JsBarcode from "jsbarcode";
import RazorpayButton from "../../Service/RazorpayButton";
import Swal from "sweetalert2";
import {
    CheckCircle,
    Building,
    CreditCard,
    Loader2,
    Mail,
    MapPin,
    Phone,
    Tag,
    User,
    Briefcase, School
} from "lucide-react";
import { Calendar, Link, Plus, Users, Archive, Shield } from "lucide-react";
import { Globe, Copy, X, Sparkles, Check, ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion"
import { Listbox } from '@headlessui/react';
const RegistrationModal = ({ toggleModal, isModal, fetchData }) => {
    const indianFlag = <IndianFlagIcon />

    const location = useLocation();
    // console.log("(new URLSearchParams(location.search))", new URLSearchParams(location.search).get("eventid"));
    const [modal, setModal] = useState(false);
    const [linkmodal, setlinkmodal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [firstName, setFirstName] = useState("");
    const [designation, setDesignation] = useState("");
    const [idCard, setIdCard] = useState([]);
    const [designations, setDesignations] = useState([]); // State to hold fetched designations
    const [Dataid, setDataid] = useState("");
    const [params, setparams] = useState(new URLSearchParams(location.search));
    const [eventId, setEventId] = useState(params.get("eventid"));
    const [eventName, setEventName] = useState("");
    const [institute, setInstitute] = useState("");
    const [email, setemail] = useState("");
    const [selectedIdCardType, setSelectedIdCardType] = useState("vertical");
    const [backgroundImage, setBackgroundImage] = useState(null);
    const [amenities, setamenities] = useState(null);
    const [profilePicture, setProfilePicture] = useState(null);
    const [phone, setPhone] = useState("");
    const [showThanksPage, setShowThanksPage] = useState(false);
    const [showIdcardLink, setShowIdcardLink] = useState("");

    const [errors, setErrors] = useState({});
    const [eventData, setEventData] = useState(null); // State to hold fetched event data

    // Ticket selection state
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [couponCode, setCouponCode] = useState("");
    const [couponCodeVerify, setCouponCodeVerify] = useState("");
    const [couponData, setCouponData] = useState({ type: null, value: 0 });
    const [currentAmount, setCurrentAmount] = useState(0);

    const [discountedAmount, setDiscountedAmount] = useState(currentAmount);
    // Derive dropdown options
    const regionOptions = eventData?.regionPricings?.map((r) => r.region) || [];
    const categoryOptions = selectedRegion
        ? eventData?.regionPricings.find((r) => r.region === selectedRegion)
            ?.categories || []
        : [];
    const [isChecking, setIsChecking] = useState(false)


    const LoaderOverlay = () => (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <Loader2 className="h-12 w-12 animate-spin text-white" />
        </div>
    );

    const fetchEVentData = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/events/${eventId}`
            );
            setEventData(response.data);
        } catch (error) {
            console.error("Error fetching event data:", error);
        }
    };
    useEffect(() => {
        fetchEVentData();
    }, [eventId]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get("eventid");
        const name = params.get("eventName");
        setparams(params);
        setEventId(id);
        setEventName(name);

        // fetchData();
    }, [location]);

    const handleCouponCodeChange = (e) => {
        setCouponCodeVerify("")
        setCouponCode(e.target.value.toUpperCase())
    }

    const checkCouponCode = async (e) => {
        e.preventDefault();
        try {
            setIsChecking(true)
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/participants/check/couponcode/${couponCode}/event/${eventId}/scope/${selectedRegion}/couponcodecheck`,
                { couponCode }
            );
            setIsChecking(false)
            setCouponCodeVerify(response.data.check);
            setCouponData({
                type: response.data.type,    // "percentage" or "fixed"
                value: response.data.value,  // e.g. 10
            });

        } catch (error) {
            setIsChecking(false)
            setCouponCodeVerify(false);
            console.error("Error checking coupon code:", error);
            return false;
        }
    };

    // --- Recompute discountedAmount whenever base amount or coupon changes ---
    useEffect(() => {
        if (couponCodeVerify && couponData.type) {
            const base = currentAmount;
            let finalAmt;
            if (couponData.type === "percentage") {
                finalAmt = Math.round(base * (1 - couponData.value / 100));
            } else {
                finalAmt = Math.max(0, base - couponData.value);
            }
            setDiscountedAmount(finalAmt);
        } else {
            setDiscountedAmount(currentAmount);
        }
    }, [currentAmount, couponData, couponCodeVerify]);

    const [isCreating, setIsCreating] = useState(false); // New state for loading spinner

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isValid()) {
            toast.dismiss();
            toast.error("Please fill all the fields");
            return;
        }
        // console.log("isvalide", isValid());
        setIsCreating(true);


        try {
            const formData = new FormData();
            formData.append("firstName", firstName);
            // formData.append("lastName", lastName);
            formData.append("designation", designation);
            formData.append("idCardType", selectedIdCardType);
            formData.append("institute", institute);
            formData.append("eventId", eventId);
            formData.append("phone", phone);
            formData.append("eventName", eventName);
            formData.append("email", email);
            // formData.append("tag", "Invited");

            formData.append("ticketRegion", selectedRegion);
            formData.append("ticketCategory", selectedCategory);

            if (couponCode) {
                formData.append("useCouponCode", couponCode);
            }
            const amenitiesObject = typeof amenities === "object" ? amenities : {};
            formData.append("amenities", JSON.stringify(amenitiesObject));

            if (eventData?.idcardimage) {
                // formData.append("backgroundImage", backgroundImage);
                formData.append("backgroundImage", eventData?.idcardimage);
            }
            if (profilePicture) {
                formData.append("profilePicture", profilePicture);
            }

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/participants`,
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
            if (eventData?.whatsappApiKey) {
                handleSend(response.data);
            }
            // fetchData(eventId);


            const token = new URLSearchParams(window.location.search).get("token");

            // Invalidate token only if form submission succeeded
            if (token) {
                await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/participants/invalidate-token`,
                    { token }
                );
            }

            setIdCard([...idCard, response.data]);
            if (isModal) {
                toggleModal();
                fetchData();
            } else {
                setShowThanksPage(true);
            }

            setShowIdcardLink(response.data.link);

            // toast.success("ID card created successfully!");
            Swal.fire("Success", "Pass generated successfully.", "success");
            // Swal.fire("Success", "Meet us at LEAP over a cup of coffee - Hall 1", "success");

            if (token) {
                navigate(`/id-created?eventid=${eventId}&eventName=${eventName}`);
            }
        } catch (error) {
            console.error("Error creating participant:", error);
            // toast.error("Failed to create participant");
            Swal.fire("Error", "Please check your internet connection.");
            if (!isModal) {
                setShowThanksPage(false);
            }
        } finally {
            setIsCreating(false);
        }
    };

    const createIdAfterPayment = async () => {
        // event.preventDefault();
        setIsCreating(true);

        try {
            const formData = new FormData();
            formData.append("firstName", firstName);
            // formData.append("lastName", lastName);
            formData.append("designation", designation);
            formData.append("idCardType", selectedIdCardType);
            formData.append("institute", institute);
            formData.append("eventId", eventId);
            formData.append("phone", phone);
            formData.append("eventName", eventName);
            formData.append("email", email);
            // formData.append("tag", "Invited");
            if (couponCode) {
                formData.append("useCouponCode", couponCode);
            }
            const amenitiesObject = typeof amenities === "object" ? amenities : {};
            formData.append("amenities", JSON.stringify(amenitiesObject));

            if (eventData?.idcardimage) {
                // formData.append("backgroundImage", backgroundImage);
                formData.append("backgroundImage", eventData?.idcardimage);
            }
            if (profilePicture) {
                formData.append("profilePicture", profilePicture);
            }

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/participants`,
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
            if (eventData?.whatsappApiKey) {
                handleSend(response.data);
            }

            const token = new URLSearchParams(window.location.search).get("token");

            // Invalidate token only if form submission succeeded
            if (token) {
                await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/participants/invalidate-token`,
                    { token }
                );
            }

            setIdCard([...idCard, response.data]);
            // fetchData(eventId);
            if (isModal) {
                fetchData();
                toggleModal();
            }
            else {
                setShowThanksPage(true);
            }
            Swal.fire("Success", "ID card generated successfully.", "success");
            setShowIdcardLink(response.data.link);
            if (token) {
                navigate(`/id-created?eventid=${eventId}&eventName=${eventName}`);
            }
        } catch (error) {
            console.error("Error creating participant:", error);
            toast.error("Failed to create participant");
            if (!isModal) {
                setShowThanksPage(false);
            }
        } finally {
            setIsCreating(false);
        }
    };



    const handleSend = async (data) => {
        // console.log("sending whatsapp message");
        const payload = {
            apiKey: eventData?.whatsappApiKey,
            campaignName: "MYU-25-Test",
            destination: phone,
            userName: "Mysuru Yoga Utsava ",
            templateParams: [`${firstName}`, `${data?.link}`],
            source: "new-landing-page form",
            media: {
                url: "https://whatsapp-media-library.s3.ap-south-1.amazonaws.com/FILE/6353da2e153a147b991dd812/4079142_dummy.pdf",
                filename: "sample_media"
            },
            buttons: [],
            carouselCards: [],
            location: {},
            attributes: {},
            paramsFallbackValue: {
                FirstName: "user"
            }
        };

        try {
            const response = await fetch("https://backend.aisensy.com/campaign/t1/api/v2", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            // console.log("Message Sent:", result);
        } catch (error) {
            console.error("Error sending message:", error);
        }
    };



    useEffect(() => {
        setBackgroundImage(designations[0]?.idcardimage);
    }, [designations]);

    useEffect(() => {
        // Assuming `designations` is an array and you are filtering for a specific event
        const eventDesignations = designations.find((d) => d._id === eventId);
        if (eventDesignations) {
            setamenities(eventDesignations.amenities || {});
        }
    }, [designations, eventId]);

    // console.log("backgroundImage", backgroundImage);
    const barcodeRef = useRef(null);

    useEffect(() => {
        if (barcodeRef.current) {
            JsBarcode(barcodeRef.current, idCard.participantId, {
                format: "CODE128",
                displayValue: true,
                height: 60, // Adjust the height here as needed
            });
        }
    }, [idCard.participantId]);

    // Function to fetch designations from API
    const fetchDesignations = async (eventId) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/events`
            );
            const filteredDesignations = response.data.filter(
                (categories) => categories._id === eventId
            );
            setDesignations(filteredDesignations);
        } catch (error) {
            console.error("Error fetching designations:", error);
        }
    };

    // console.log("categories", designations);

    const navigate = useNavigate();

    // Check if the form is being accessed with a token
    const [isSecureForm, setIsSecureForm] = useState(false);

    useEffect(() => {
        const token = new URLSearchParams(location.search).get("token");
        if (token) {
            setIsSecureForm(true);
            // Verify token is valid
            const verifyToken = async () => {
                try {
                    await axios.get(
                        `${process.env.REACT_APP_API_URL}/api/participants/verify-token`,
                        {
                            headers: { Authorization: token },
                        }
                    );
                } catch (error) {
                    // If token is invalid, redirect to an error page
                    navigate("/token-expired");
                }
            };
            verifyToken();
        }
    }, [location, navigate]);

    const isFormFilled = () =>
        !!firstName.trim() &&
        // !!designation.trim() &&
        // !!institute.trim() &&
        // !!email.trim() &&
        !!phone.trim();

    const isValid = (skipErrorSetting = false) => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10}$/;

        if (!firstName.trim()) newErrors.firstName = "Name is required.";
        // if (!designation.trim()) newErrors.designation = "Designation is required.";
        // if (!institute.trim()) newErrors.institute = "Institute is required.";
        if (!email.trim()) newErrors.email = "Email is required.";

        if (email.trim() && !emailRegex.test(email.trim()))
            newErrors.email = "Enter a valid email.";

        if (!phone.trim()) newErrors.phone = "Phone is required.";
        // else if (!phoneRegex.test(phone.trim()))
        //     newErrors.phone = "Phone must be 10 digits.";

        if (eventData?.isPaidEvent) {
            if (!selectedRegion)
                newErrors.ticketRegion = "Ticket Region is required.";
            if (!selectedCategory)
                newErrors.ticketCategory = "Ticket Category is required.";
        }

        // only write into state when you really want errors shown
        if (!skipErrorSetting) {
            setErrors(newErrors);
        }

        return Object.keys(newErrors).length === 0;
    };


    const RegistrationFormContent = {
        "modal": {
            "header": `Create ID`,
            "subHeader": `Fill in your details to generate your ID card`
        },
        "noModal": {
            "header": `Registration Form`,
            "subHeader": `Fill in your details to generate your ID card`
        }
    }

    const ThanksPage = () => {
        return (
            <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center p-4">
                <div className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8 w-full max-w-lg text-center transform animate-in fade-in-0 zoom-in-95 duration-500">
                    <div className="mb-8">
                        <div className="relative mx-auto w-20 h-20 mb-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full animate-pulse"></div>
                            <div className="relative bg-white rounded-full p-4 shadow-lg">
                                <CheckCircle className="w-12 h-12 text-green-500" />
                            </div>
                        </div>
                        <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
                            Registration Successful!
                        </h1>
                        <p className="text-gray-600 text-lg leading-relaxed">
                            Your Coupon has been created successfully.
                        </p>
                    </div>

                    <div className="space-y-6">
                        <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4">
                            <p className="text-green-700 text-sm font-medium">
                                You will receive a confirmation email shortly with your Coupon
                                details.
                            </p>
                        </div>

                        <div className="space-y-3">
                            <button
                                onClick={() => setShowThanksPage(false)}
                                className="w-full py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl hover:from-indigo-700 hover:to-purple-700 transform hover:scale-[1.02] transition-all duration-200 shadow-lg hover:shadow-xl"
                            >
                                Register Another Person
                            </button>
                            <a
                                href={showIdcardLink}
                                className="w-full block py-4 bg-gradient-to-r from-green-600 to-emerald-600 text-white font-semibold rounded-xl hover:from-green-700 hover:to-emerald-700 transform hover:scale-[1.02] transition-all duration-200 shadow-lg hover:shadow-xl text-center"
                            >
                                View Your Coupon
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const getInputStyles = () => {
        if (couponCodeVerify === true) {
            return "border-green-500 bg-green-50 focus:ring-green-200"
        }
        if (couponCodeVerify === false) {
            return "border-red-500 bg-red-50 focus:ring-red-200"
        }
        return "border-gray-300 bg-white focus:ring-blue-200"
    }

    const getButtonStyles = () => {
        if (couponCodeVerify === true) {
            return "bg-green-500 hover:bg-green-600"
        }
        if (couponCodeVerify === false) {
            return "bg-red-500 hover:bg-red-600"
        }
        return "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-400 hover:to-blue-500"
    }

    // Update the initial pricing setup when eventData loads
    useEffect(() => {
        if (eventData?.regionPricings.length > 0) {
            setSelectedRegion(eventData.regionPricings[0]?.region)
        }

        // Set initial price based on the new pricing structure
        if (eventData?.regionPricings.length > 0) {
            const firstCategory = eventData.regionPricings[0]?.categories[0];
            if (firstCategory) {
                // Prioritize early bird price, fallback to regular price, then legacy price
                const effectivePrice = firstCategory.earlyBirdPrice || firstCategory.regularPrice || firstCategory.price || 0;
                setCurrentAmount(effectivePrice);
            }
        }
        setamenities(eventData?.amenities);
    }, [eventData])

    // Update price when region or category changes
    useEffect(() => {
        const selectedCategoryData = eventData?.regionPricings
            .find((r) => r.region === selectedRegion)
            ?.categories.find((c) => c.name === selectedCategory);

        if (selectedCategoryData) {
            // Prioritize early bird price, fallback to regular price, then legacy price
            const effectivePrice = selectedCategoryData.earlyBirdPrice || selectedCategoryData.regularPrice || selectedCategoryData.price || 0;
            setCurrentAmount(effectivePrice);
        } else {
            setCurrentAmount(0);
        }

        setCouponCode("")
        setCouponCodeVerify("")
    }, [selectedRegion, selectedCategory, eventData])


    if (showThanksPage) return <ThanksPage />;


    return (
        <>


            {/* Updated Form Design - Modern Card-based Layout */}
            <div className="relative w-full max-w-4xl mx-auto overflow-hidden">
                <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-100">
                    {/* Header - Keep existing background color */}
                    <div className="relative bg-[#E47378] px-8 py-6 rounded-t-2xl">
                        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 rounded-t-2xl via-purple-600/10 to-indigo-700/10 backdrop-blur-sm"></div>
                        <div className="relative z-10 flex items-center rounded-t-2xl justify-between">
                            <div className="flex items-center space-x-4">
                                <div className="">
                                    <h2 className="text-3xl font-bold text-white text-start">
                                        {eventData?.formHeader}
                                    </h2>
                                    <p className="text-indigo-100 text-start mt-1">
                                        {eventData?.formSubHeader}
                                    </p>
                                </div>
                            </div>
                            {isModal && <button
                                type="button"
                                onClick={toggleModal}
                                className="group w-10 h-10 bg-white/20 hover:bg-white/30 rounded-xl flex items-center justify-center backdrop-blur-sm transition-all duration-300 hover:scale-105"
                            >
                                <X className="w-5 h-5 text-white group-hover:rotate-90 transition-transform duration-300" />
                            </button>}
                        </div>

                        {/* Animated background particles */}
                        <div className="absolute inset-0 overflow-hidden pointer-events-none">
                            <div className="absolute top-4 left-12 w-1 h-1 bg-white/40 rounded-full animate-pulse"></div>
                            <div className="absolute top-8 right-16 w-0.5 h-0.5 bg-white/50 rounded-full animate-pulse delay-300"></div>
                            <div className="absolute bottom-6 left-20 w-1.5 h-1.5 bg-white/30 rounded-full animate-pulse delay-700"></div>
                        </div>
                    </div>

                    {/* Content - Completely New Design */}
                    <div className={`overflow-y-auto custom-scrollbar ${isModal ? "max-h-[70vh] " : ""}`}>
                        <div className="p-2 md:p-6 bg-gradient-to-br from-slate-50 via-white to-blue-50/30">
                            <form className="space-y-6" onSubmit={handleSubmit}>
                                {isCreating && <LoaderOverlay />}

                                {/* Personal Information Section */}
                                <div className="bg-white rounded-xl md:p-6 border border-slate-200 shadow-sm">
                                    <div className="flex items-center space-x-2 mb-4">
                                        <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                                            <User className="w-4 h-4 text-white" />
                                        </div>
                                        <h3 className="text-lg font-semibold text-gray-800">Personal Information</h3>
                                    </div>

                                    {/* Name Field */}
                                    <div className="group mb-4">
                                        <label htmlFor="startname" className="block text-sm font-medium text-gray-700 mb-2">
                                            Full Name *
                                        </label>
                                        <div className="relative">
                                            <input
                                                className="w-full h-11 px-4 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 text-gray-800 placeholder-gray-500"
                                                id="startname"
                                                placeholder="Enter your full name"
                                                required
                                                value={firstName}
                                                onChange={(e) => setFirstName(e.target.value)}
                                            />
                                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                                <User className="w-4 h-4 text-gray-400" />
                                            </div>
                                        </div>
                                        {errors.firstName && (
                                            <p className="text-red-500 text-sm mt-1 flex items-center space-x-1">
                                                <span className="w-1 h-1 bg-red-500 rounded-full"></span>
                                                <span>{errors.firstName}</span>
                                            </p>
                                        )}
                                    </div>

                                    {/* Contact Information Grid */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        {/* Phone Field */}
                                        <div className="group">
                                            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                                                Phone Number *
                                            </label>
                                            <div className="relative">
                                                <input
                                                    className="w-full h-11 px-4 pl-10 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all duration-200 text-gray-800 placeholder-gray-500"
                                                    id="phone"
                                                    placeholder="Enter phone number"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                />
                                                <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                                                    <Phone className="w-4 h-4 text-gray-400" />
                                                </div>
                                            </div>
                                            {errors.phone && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center space-x-1">
                                                    <span className="w-1 h-1 bg-red-500 rounded-full"></span>
                                                    <span>{errors.phone}</span>
                                                </p>
                                            )}
                                        </div>

                                        {/* Email Field */}
                                        <div className="group">
                                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                                Email Address *
                                            </label>
                                            <div className="relative">
                                                <input
                                                    className="w-full h-11 px-4 pl-10 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all duration-200 text-gray-800 placeholder-gray-500"
                                                    id="email"
                                                    placeholder="Enter email address"
                                                    value={email}
                                                    onChange={(e) => setemail(e.target.value)}
                                                />
                                                <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                                                    <Mail className="w-4 h-4 text-gray-400" />
                                                </div>
                                            </div>
                                            {errors.email && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center space-x-1">
                                                    <span className="w-1 h-1 bg-red-500 rounded-full"></span>
                                                    <span>{errors.email}</span>
                                                </p>
                                            )}
                                        </div>
                                        {/* Institute Field */}
                                        <div className="group">
                                            <label htmlFor="institute" className="block text-sm font-medium text-gray-700 mb-2">
                                                Organization/Institute
                                            </label>
                                            <div className="relative">
                                                <input
                                                    className="w-full h-11 px-4 pl-10 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all duration-200 text-gray-800 placeholder-gray-500"
                                                    id="institute"
                                                    placeholder="Enter institute name"
                                                    value={institute}
                                                    onChange={(e) => setInstitute(e.target.value)}
                                                />
                                                <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                                                    <School className="w-4 h-4 text-gray-400" />
                                                </div>
                                            </div>
                                            {errors.institute && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center space-x-1">
                                                    <span className="w-1 h-1 bg-red-500 rounded-full"></span>
                                                    <span>{errors.institute}</span>
                                                </p>
                                            )}
                                        </div>
                                        {/* Designation Field */}
                                        <div className="group">
                                            <label htmlFor="designation" className="block text-sm font-medium text-gray-700 mb-2">
                                                Designation
                                            </label>
                                            <div className="relative">
                                                <input
                                                    className="w-full h-11 px-4 pl-10 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 text-gray-800 placeholder-gray-500"
                                                    id="designation"
                                                    placeholder="Enter designation"
                                                    value={designation}
                                                    onChange={(e) => setDesignation(e.target.value)}
                                                />
                                                <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                                                    <Briefcase className="w-4 h-4 text-gray-400" />
                                                </div>
                                            </div>
                                            {errors.designation && (
                                                <p className="text-red-500 text-sm mt-1 flex items-center space-x-1">
                                                    <span className="w-1 h-1 bg-red-500 rounded-full"></span>
                                                    <span>{errors.designation}</span>
                                                </p>
                                            )}
                                        </div>

                                    </div>

                                </div>

                                {/* Ticket Selection Section */}
                                {(eventData?.regionPricings.length > 0 && eventData?.isPaidEvent) && (
                                    <div className="bg-white rounded-xl md:p-6 border border-slate-200 shadow-sm">
                                        <div className="flex items-center space-x-2 mb-4">
                                            <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-600 rounded-lg flex items-center justify-center">
                                                <Tag className="w-4 h-4 text-white" />
                                            </div>
                                            <h3 className="text-lg font-semibold text-gray-800">Ticket Selection</h3>
                                        </div>

                                        {/* Region Selection - Enhanced Design */}
                                        <div className="mb-6">
                                            <label className="block text-sm font-medium text-gray-700 mb-3">
                                                Select Region *
                                            </label>

                                            <div className="relative group">
                                                <Listbox value={selectedRegion} onChange={(value) => {
                                                    setSelectedRegion(value);
                                                    setSelectedCategory("");
                                                }}>
                                                    {({ open }) => (
                                                        <>
                                                            <Listbox.Button className="w-full h-12 px-4 pr-12 bg-white border-2 border-gray-200 rounded-xl focus:border-teal-500 focus:ring-4 focus:ring-teal-100 transition-all duration-300 text-gray-800 font-medium text-left cursor-pointer hover:border-teal-300 hover:shadow-md hover:bg-gray-50 group-hover:border-teal-300">
                                                                <span>
                                                                    {selectedRegion && (
                                                                        <span className="flex items-center gap-2">
                                                                            {selectedRegion.toLowerCase() === "indian" ? (
                                                                                <span className="w-6 h-6 rounded-full overflow-hidden flex items-center justify-center bg-white">
                                                                                    <IndianFlagIcon />
                                                                                </span>
                                                                            ) : (
                                                                                <span className="text-xl">🌍</span>
                                                                            )}
                                                                            <span>{selectedRegion.charAt(0).toUpperCase() + selectedRegion.slice(1)}</span>
                                                                        </span>
                                                                    )}
                                                                </span>
                                                                <span className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                                                    <motion.div
                                                                        animate={{ rotate: open ? 180 : 0 }}
                                                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                                                    >
                                                                        <ChevronDown className={`w-5 h-5 ${selectedRegion ? 'text-teal-500' : 'text-gray-400 group-hover:text-teal-400'}`} />
                                                                    </motion.div>
                                                                </span>
                                                            </Listbox.Button>

                                                            <AnimatePresence>
                                                                {open && (
                                                                    <motion.ul
                                                                        initial={{ opacity: 0, y: -10 }}
                                                                        animate={{ opacity: 1, y: 0 }}
                                                                        exit={{ opacity: 0, y: -10 }}
                                                                        className="absolute z-10 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-auto"
                                                                    >
                                                                        {regionOptions.map((region) => (
                                                                            <Listbox.Option
                                                                                key={region}
                                                                                value={region}
                                                                                className={({ active }) =>
                                                                                    `cursor-pointer select-none px-4 py-2 font-semibold text-gray-800 ${active ? 'bg-teal-100' : ''}`
                                                                                }
                                                                            >
                                                                                <div className="flex items-center  gap-3">
                                                                                    {region.toLowerCase() === "indian" ? (
                                                                                        <span className="w-6 h-6 rounded-full overflow-hidden flex items-center justify-center bg-white">
                                                                                            <IndianFlagIcon />
                                                                                        </span>
                                                                                    ) : (
                                                                                        <span className="w-6 h-6 rounded-full overflow-hidden flex items-center text-xl justify-center bg-white">🌍</span>
                                                                                    )} <span>{region.charAt(0).toUpperCase() + region.slice(1)}</span>
                                                                                </div>
                                                                            </Listbox.Option>
                                                                        ))}
                                                                    </motion.ul>
                                                                )}
                                                            </AnimatePresence>
                                                        </>
                                                    )}
                                                </Listbox>

                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-50/20 to-transparent pointer-events-none rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                            </div>

                                            {/* Error display (optional) */}
                                            {errors.ticketRegion && (
                                                <p className="text-red-500 text-sm mt-2">{errors.ticketRegion}</p>
                                            )}
                                        </div>



                                        {/* Category Selection - Modern Card Grid */}
                                        {selectedRegion && (
                                            <div className="space-y-3">
                                                <label className="block text-sm font-medium text-gray-700">
                                                    Choose Ticket Category *
                                                </label>

                                                <div className="grid gap-3 overflow-y-auto custom-scrollbar">
                                                    {categoryOptions.map((category, index) => {
                                                        const isSelected = selectedCategory === category.name;
                                                        const currencySymbol = selectedRegion === "indian" ? "₹" : "$";
                                                        const hasEarlyBird = category.earlyBirdPrice && category.regularPrice;
                                                        const effectivePrice = category.earlyBirdPrice || category.regularPrice || category.price || 0;
                                                        const savings = hasEarlyBird ? category.regularPrice - category.earlyBirdPrice : 0;

                                                        return (
                                                            <div
                                                                key={category.name}
                                                                onClick={() => setSelectedCategory(category.name)}
                                                                className={`relative cursor-pointer rounded-lg border-2 p-4 transition-all duration-200 ${isSelected
                                                                    ? 'border-blue-500 bg-blue-50 shadow-md'
                                                                    : 'border-gray-200 bg-white hover:border-blue-300 hover:shadow-sm'
                                                                    }`}
                                                            >
                                                                {/* Dropdown Icon */}
                                                                <div className="absolute top-4 right-4">
                                                                    <motion.div
                                                                        animate={{ rotate: isSelected ? 180 : 0 }}
                                                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                                                        className={`w-5 h-5 flex items-center justify-center ${isSelected ? 'text-blue-500' : 'text-gray-400'
                                                                            }`}
                                                                    >
                                                                        <svg
                                                                            className="w-5 h-5"
                                                                            fill="none"
                                                                            stroke="currentColor"
                                                                            viewBox="0 0 24 24"
                                                                        >
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                                        </svg>
                                                                    </motion.div>
                                                                </div>

                                                                <div className="pr-8">
                                                                    {/* Category Name */}
                                                                    <h4 className={`font-semibold text-base mb-2 ${isSelected ? 'text-blue-700' : 'text-gray-800'
                                                                        }`}>
                                                                        {category.name}
                                                                    </h4>

                                                                    {/* Pricing Info */}
                                                                    <div className="flex items-center space-x-4 mb-3">
                                                                        <div className="flex items-center space-x-2">
                                                                            <span className="text-lg font-bold text-gray-800">
                                                                                {currencySymbol}{effectivePrice}
                                                                            </span>
                                                                            {hasEarlyBird ? (
                                                                                <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">
                                                                                    Early Bird
                                                                                </span>
                                                                            ) : null}
                                                                        </div>

                                                                        {savings > 0 ? (
                                                                            <div className="text-right">
                                                                                <div className="text-sm text-gray-500 line-through">
                                                                                    {currencySymbol}{category.regularPrice}
                                                                                </div>
                                                                                <div className="text-sm font-medium text-green-600">
                                                                                    Save {currencySymbol}{savings}
                                                                                </div>
                                                                            </div>
                                                                        ) : null}
                                                                    </div>

                                                                    {/* Additional Info */}
                                                                    <div className="flex flex-wrap gap-2">
                                                                        {hasEarlyBird ? (
                                                                            <span className="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded-full">
                                                                                Limited Time
                                                                            </span>
                                                                        ) : null}
                                                                        {category.effectiveDailyRate ? (
                                                                            <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                                                                                Daily: {currencySymbol}{category.effectiveDailyRate}
                                                                            </span>
                                                                        ) : null}
                                                                    </div>

                                                                    {/* Category Details with Animation */}
                                                                    <AnimatePresence>
                                                                        {isSelected && category.headerDescriptions && category.headerDescriptions.length > 0 && (
                                                                            <motion.div
                                                                                initial={{ opacity: 0, height: 0, y: -10 }}
                                                                                animate={{
                                                                                    opacity: 1,
                                                                                    height: "auto",
                                                                                    y: 0,
                                                                                    transition: {
                                                                                        opacity: { delay: 0.2, duration: 0.3 },
                                                                                        height: { delay: 0.1, duration: 0.4 },
                                                                                        y: { delay: 0.2, duration: 0.3 }
                                                                                    }
                                                                                }}
                                                                                exit={{
                                                                                    opacity: 0,
                                                                                    height: 0,
                                                                                    y: -10,
                                                                                    transition: { duration: 0.2 }
                                                                                }}
                                                                                className="mt-4 pt-3 border-t border-blue-200 overflow-hidden"
                                                                            >
                                                                                <h5 className="text-lg font-medium text-gray-700 mb-2">Description</h5>
                                                                                <div className="space-y-2 overflow-y-auto">
                                                                                    {category.headerDescriptions.map((hd, hdIndex) => (
                                                                                        <motion.div
                                                                                            key={hdIndex}
                                                                                            initial={{ opacity: 0, x: -10 }}
                                                                                            animate={{
                                                                                                opacity: 1,
                                                                                                x: 0,
                                                                                                transition: {
                                                                                                    delay: 0.3 + (hdIndex * 0.1),
                                                                                                    duration: 0.3
                                                                                                }
                                                                                            }}
                                                                                            className="bg-blue-50 rounded-md p-2"
                                                                                        >
                                                                                            <h6 className="font-medium text-blue-800 text-sm">{hd.header}</h6>
                                                                                            <p className="text-gray-600 text-xs mt-1 whitespace-pre-wrap">{hd.description}</p>
                                                                                        </motion.div>
                                                                                    ))}
                                                                                </div>
                                                                            </motion.div>
                                                                        )}
                                                                    </AnimatePresence>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>

                                                {errors.ticketCategory && (
                                                    <p className="text-red-500 text-sm flex items-center space-x-1">
                                                        <span className="w-1 h-1 bg-red-500 rounded-full"></span>
                                                        <span>{errors.ticketCategory}</span>
                                                    </p>
                                                )}
                                            </div>
                                        )}

                                    </div>
                                )}

                                {/* Coupon Code Section */}
                                {selectedRegion && selectedCategory && eventData?.isPaidEvent && (
                                    <div className="bg-white rounded-xl md:p-6 border border-slate-200 shadow-sm">
                                        <div className="flex items-center space-x-2 mb-4">
                                            <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg flex items-center justify-center">
                                                <Tag className="w-4 h-4 text-white" />
                                            </div>
                                            <h3 className="text-lg font-semibold text-gray-800">Coupon Code</h3>
                                        </div>

                                        <motion.div
                                            className="space-y-3"
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <div className="relative">
                                                <div className="flex">
                                                    <motion.input
                                                        type="text"
                                                        value={couponCode}
                                                        onChange={handleCouponCodeChange}
                                                        className={`flex-1 h-11 px-4 border rounded-l-lg focus:ring-2 focus:outline-none uppercase font-mono text-sm transition-all duration-200 ${getInputStyles()}`}
                                                        placeholder="ENTER COUPON CODE"
                                                        disabled={isChecking}
                                                        layout
                                                    />

                                                    <motion.button
                                                        className={`px-6 py-3 rounded-r-lg text-white font-medium transition-all duration-200 flex items-center justify-center min-w-[80px] ${getButtonStyles()}`}
                                                        onClick={checkCouponCode}
                                                        disabled={isChecking || !couponCode.trim()}
                                                        whileTap={{ scale: 0.95 }}
                                                        layout
                                                    >
                                                        <AnimatePresence mode="wait">
                                                            {isChecking ? (
                                                                <motion.div
                                                                    key="loading"
                                                                    initial={{ opacity: 0, rotate: 0 }}
                                                                    animate={{ opacity: 1, rotate: 360 }}
                                                                    exit={{ opacity: 0 }}
                                                                    transition={{
                                                                        rotate: { duration: 1, repeat: Number.POSITIVE_INFINITY, ease: "linear" },
                                                                        opacity: { duration: 0.2 },
                                                                    }}
                                                                >
                                                                    <Loader2 className="w-5 h-5" />
                                                                </motion.div>
                                                            ) : couponCodeVerify === true ? (
                                                                <motion.div
                                                                    key="success"
                                                                    initial={{ opacity: 0, scale: 0 }}
                                                                    animate={{ opacity: 1, scale: 1 }}
                                                                    exit={{ opacity: 0, scale: 0 }}
                                                                    transition={{
                                                                        type: "spring",
                                                                        stiffness: 500,
                                                                        damping: 15,
                                                                    }}
                                                                >
                                                                    <Check className="w-5 h-5" />
                                                                </motion.div>
                                                            ) : couponCodeVerify === false ? (
                                                                <motion.div
                                                                    key="error"
                                                                    initial={{ opacity: 0, scale: 0 }}
                                                                    animate={{ opacity: 1, scale: 1 }}
                                                                    exit={{ opacity: 0, scale: 0 }}
                                                                    transition={{
                                                                        type: "spring",
                                                                        stiffness: 500,
                                                                        damping: 15,
                                                                    }}
                                                                >
                                                                    <X className="w-5 h-5" />
                                                                </motion.div>
                                                            ) : (
                                                                <motion.span key="apply" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                                                                    Apply
                                                                </motion.span>
                                                            )}
                                                        </AnimatePresence>
                                                    </motion.button>
                                                </div>
                                            </div>

                                            <AnimatePresence>
                                                {couponCodeVerify === true && (
                                                    <motion.div
                                                        initial={{ opacity: 0, y: -10 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        exit={{ opacity: 0, y: -10 }}
                                                        className="bg-green-50 border border-green-200 rounded-lg p-3 flex items-center text-green-700"
                                                    >
                                                        <Check className="w-4 h-4 mr-2" />
                                                        <span className="text-sm font-medium">Coupon applied successfully!</span>
                                                    </motion.div>
                                                )}

                                                {couponCodeVerify === false && (
                                                    <motion.div
                                                        initial={{ opacity: 0, y: -10 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        exit={{ opacity: 0, y: -10 }}
                                                        className="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center text-red-700"
                                                    >
                                                        <X className="w-4 h-4 mr-2" />
                                                        <span className="text-sm font-medium">Invalid coupon code. Please try again.</span>
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>

                                            <p className="text-xs text-gray-500">
                                                Enter a valid coupon code to get a discount on your registration.
                                            </p>
                                        </motion.div>
                                    </div>
                                )}

                                {/* Price Summary Section - Updated with Discount Display */}
                                {selectedCategory && eventData?.isPaidEvent && (
                                    <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl p-6 text-white shadow-lg">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <h3 className="text-lg font-semibold mb-1"> Price Summary</h3>
                                                <p className="text-blue-100 text-sm">{selectedCategory}</p>

                                                {(() => {
                                                    const categoryData = eventData?.regionPricings
                                                        .find((r) => r.region === selectedRegion)
                                                        ?.categories.find((c) => c.name === selectedCategory);

                                                    if (categoryData?.earlyBirdPrice && categoryData?.regularPrice) {
                                                        const savings = categoryData.regularPrice - categoryData.earlyBirdPrice;
                                                        const percentage = Math.round((savings / categoryData.regularPrice) * 100);

                                                        return (
                                                            <div className="mt-2">
                                                                <p className="text-blue-200 text-sm line-through">
                                                                    Regular: {selectedRegion === "indian" ? "₹" : "$"}{categoryData.regularPrice}
                                                                </p>
                                                                <p className="text-green-300 text-sm font-medium">
                                                                    Save {percentage}% • {selectedRegion === "indian" ? "₹" : "$"}{savings}
                                                                </p>
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })()}
                                            </div>

                                            <div className="text-right">
                                                {/* Show discounted price if coupon is applied */}
                                                {couponCodeVerify && discountedAmount !== currentAmount ? (
                                                    <div className="space-y-1">
                                                        <div className="text-lg text-blue-200 line-through">
                                                            {selectedRegion === "indian" ? "₹" : "$"}{currentAmount}
                                                        </div>
                                                        <div className="text-3xl font-bold text-green-300">
                                                            {selectedRegion === "indian" ? "₹" : "$"}{discountedAmount}
                                                        </div>
                                                        <div className="bg-green-500/20 text-green-200 text-xs font-medium px-2 py-1 rounded-full inline-block">
                                                            Saved {selectedRegion === "indian" ? "₹" : "$"}{currentAmount - discountedAmount}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="text-3xl font-bold">
                                                        {selectedRegion === "indian" ? "₹" : "$"}{currentAmount}
                                                    </div>
                                                )}
                                                <p className="text-blue-200 text-sm">Total Amount</p>
                                            </div>
                                        </div>

                                        {/* Additional discount information if coupon is applied */}
                                        {couponCodeVerify && discountedAmount !== currentAmount && (
                                            <div className="mt-4 pt-4 border-t border-white/20">
                                                <div className="flex items-center justify-between text-sm">
                                                    <div className="flex items-center space-x-2">
                                                        <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
                                                            <Check className="w-3 h-3 text-white" />
                                                        </div>
                                                        <span className="text-green-200 font-medium">Coupon Applied: {couponCode}</span>
                                                    </div>
                                                    <div className="text-right">
                                                        <div className="text-green-300 font-semibold">
                                                            {couponData.type === 'percentage'
                                                                ? `${couponData.value}% OFF`
                                                                : `${selectedRegion === "indian" ? "₹" : "$"}${couponData.value} OFF`
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                            </form>
                        </div>
                    </div>

                    {/* Footer - Modern Button Design */}
                    <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 rounded-b-2xl">
                        <div className="flex gap-3">
                            {/* Cancel Button */}
                            {isModal && (
                                <button
                                    type="button"
                                    onClick={toggleModal}
                                    className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors duration-200 flex items-center justify-center space-x-2"
                                >
                                    <X className="w-4 h-4" />
                                    <span>Cancel</span>
                                </button>
                            )}

                            {/* Create/Pay Button */}
                            {(eventData?.isPaidEvent && discountedAmount > 0) ? (
                                <div className="flex-1">
                                    <RazorpayButton
                                        RazorPaySecret={eventData?.razorpaySecret}
                                        RazorpayApiKey={eventData?.razorpayKey}
                                        styleClass={`w-full py-3 px-4 font-medium rounded-lg transition-all duration-200 flex items-center justify-center space-x-2 ${isFormFilled()
                                            ? "bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white shadow-lg hover:shadow-xl"
                                            : "bg-gray-300 text-gray-500 cursor-not-allowed"
                                            }`}
                                        onSuccess={createIdAfterPayment}
                                        buttonText={
                                            selectedCategory
                                                ? `Pay ${selectedRegion === "indian" ? "₹" : "$"}${discountedAmount} & Create ID`
                                                : "Select ticket first"
                                        }
                                        amount={discountedAmount}
                                        user={{
                                            firstName,
                                            email,
                                            phone,
                                        }}
                                        currency={selectedRegion === "indian" ? "INR" : "USD"}
                                        loading={isCreating}
                                        onBeforePay={() => isValid()}
                                    />
                                </div>
                            ) : (
                                <button
                                    onClick={handleSubmit}
                                    className="flex-1 bg-[#D66C81] hover:bg-[#C55A75] text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={isCreating}
                                >
                                    {isCreating ? (
                                        <>
                                            <Loader2 className="w-4 h-4 animate-spin" />
                                            <span>Creating...</span>
                                        </>
                                    ) : (
                                        <>
                                            <Plus className="w-4 h-4" />
                                            <span>Create ID</span>
                                        </>
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Custom Scrollbar Styles */}
                <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
            background: rgba(229, 231, 235, 0.5);
            border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
            background: linear-gradient(to bottom, #3b82f6, #8b5cf6);
            border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(to bottom, #2563eb, #7c3aed);
        }
    `}</style>
            </div>

        </>
    )
}

export default RegistrationModal




const IndianFlagIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 480 480"
        className="w-full h-full"
    >
        <circle cx="240" cy="240" r="240" fill="#f93" />
        <path fill="#fff" d="M0 160h480v160H0z" />
        <path fill="#128807" d="M0 320h480v160H0z" />
        <circle cx="240" cy="240" r="40" fill="#008" />
        <circle cx="240" cy="240" r="6" fill="#fff" />
    </svg>
);